var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonSignpost(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 60,
    viewBox: "0 0 56 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.125 11.125C24.15 11.125 26.625 8.65 26.625 5.625C26.625 2.6 24.15 0.125 21.125 0.125C18.1 0.125 15.625 2.6 15.625 5.625C15.625 8.65 18.1 11.125 21.125 11.125ZM10.8125 20.475L3.25 59.25H9.025L13.8375 37.25L19.75 42.75V59.25H25.25V38.4875L19.6125 32.85L21.2625 24.6C24.8375 29 30.2 31.75 36.25 31.75V26.25C31.1625 26.25 26.7625 23.5 24.2875 19.5125L21.675 15.1125C20.7125 13.4625 18.925 12.5 17 12.5C16.3125 12.5 15.625 12.6375 14.9375 12.9125L0.5 18.825V31.75H6V22.5375L10.8125 20.475ZM30.75 1.5V20.75H41.0625V59.25H45.1875V20.75H55.5V1.5H30.75ZM44.5275 18V13.1875H34.875V9.0625H44.5275V4.25L51.375 11.125L44.5275 18Z",
    fill: "#4D7766"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonSignpost);
export default __webpack_public_path__ + "static/media/person_signpost.c3fa79649f0952020285982c02e59f91.svg";
export { ForwardRef as ReactComponent };